import HelpCenter from 'components/pages/HelpCenter/HelpCenter.lifepoints';
import { buildPage } from 'utils/pageHelper';

export default buildPage(HelpCenter, {
  requiresAuthentication: false,
  metaData: {
    title: 'Help Center',
    description: 'Redirects to the Help Center.',
  },
});
